import React, { useMemo } from 'react';
import { track } from '../../services/analytics';
import { getExperiencesByCategory } from '../../data/affiliateProducts';

const ExperiencesSection = () => {
  const experiences = useMemo(() => getExperiencesByCategory('general', 6), []);

  if (!experiences || experiences.length === 0) return null;

  const handleClick = (item, position) => {
    track('affiliate_click', {
      product: item.name,
      productId: item.id,
      category: item.category,
      program: item.program,
      position: `homepage_experiences_${position}`,
    });
  };

  const featured = experiences[0];
  const secondary = experiences.slice(1, 3);

  return (
    <section className="py-32 px-8 bg-surface-container-lowest">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-end mb-16">
          <div>
            <h2 className="font-headline text-4xl mb-4 text-on-surface">Recommended Experiences</h2>
            <p className="font-body text-slate-400 max-w-xl">
              Scholarly curated expeditions to witness the planet's most significant migratory events in person.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {featured && (
            <a
              href={featured.url}
              target="_blank"
              rel="sponsored noopener noreferrer"
              onClick={() => handleClick(featured, 0)}
              className="md:col-span-8 group relative overflow-hidden rounded-xl bg-surface-container-high h-[500px]"
            >
              <img
                alt={featured.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                src={featured.image}
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-surface-container-highest via-transparent to-transparent opacity-90"></div>
              <div className="absolute bottom-0 left-0 p-10">
                <span className="inline-block bg-secondary text-on-secondary px-3 py-1 rounded-full text-[10px] font-label font-bold uppercase tracking-tighter mb-4">
                  {featured.category}
                </span>
                <h3 className="font-headline text-3xl mb-2 text-on-surface">{featured.name}</h3>
                <p className="text-on-surface-variant max-w-md font-body text-sm mb-4">{featured.description}</p>
                <span className="text-primary font-label font-semibold">{featured.price}</span>
              </div>
            </a>
          )}

          <div className="md:col-span-4 space-y-8">
            {secondary.map((item, i) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="sponsored noopener noreferrer"
                onClick={() => handleClick(item, i + 1)}
                className="group relative overflow-hidden rounded-xl bg-surface-container-high h-[234px] block"
              >
                <img
                  alt={item.name}
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-all duration-700"
                  src={item.image}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-surface-container-highest to-transparent"></div>
                <div className="absolute inset-0 flex flex-col justify-end p-6">
                  <h4 className="font-headline text-xl text-on-surface">{item.name}</h4>
                  <p className="text-xs text-on-surface-variant font-label">{item.price}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperiencesSection;
